import { Component } from '@angular/core';
import { LoaderEnum } from 'libs/core/src/lib/enum/loader.enum';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { VoucherService } from 'libs/core/src/lib/service/voucher.service';
import { OrderStateService } from 'libs/core/src/lib/state/order.state.service';
import { CustomLoyaltyInputComponent } from '../../loyalty-input/loyalty-input.component';
import { ErrorHandlerService } from 'libs/core/src/lib/service/error-handler/error-handler.service';

@Component({ standalone: false, selector: 'app-voucher-input', templateUrl: './voucher-input.component.html' })
export class CustomVoucherInputComponent extends CustomLoyaltyInputComponent {
  constructor(
    protected loaderService: LoaderService,
    protected orderStateService: OrderStateService,
    protected voucherService: VoucherService,
    private errorHandlerService: ErrorHandlerService
  ) {
    super(loaderService, orderStateService);
  }

  submit() {
    if (!this.value || !this.order) {
      return;
    }

    if (this.onSubmit.observed) {
      this.onSubmit.emit(this.value);
      this.value = '';
      return;
    }

    this.errors = [];
    this.loaderService.showLoader(LoaderEnum.MAIN);

    this.voucherService.assignVoucherToOrderViaApiModel(this.order.cinemaId, this.order.id, this.value).subscribe({
      next: (res) => {
        this.orderStateService.setOrder(res);
        this.clear();
        this.loaderService.hideLoader(LoaderEnum.MAIN);
      },
      error: (e) => {
        const error = this.errorHandlerService.getError(e, null, true);
        if (error) {
          switch (error.code) {
            case '460':
              this.errors = ['voucher_not_found'];
              break;
            case '461':
              this.errors = ['voucher_already_used'];
              break;
          }
        }

        if (!this.errors || this.errors?.length === 0) {
          this.errors = ['cannot_use'];
        }
        this.loaderService.hideLoader(LoaderEnum.MAIN);
      }
    });
  }
}
